<template>
  <div class="campaign-info wd-flex wd-items-start wd-gap-2" :class="{ 'wd-cursor-pointer': isClickable }" @click="handleClick">
    <!-- Leading: celebration icon -->
    <FunnowIcon image-path="celebration.svg" class="wd-w-6 wd-h-6 wd-text-black50" />

    <!-- Main: title + description -->
    <div class="wd-flex-1">
      <p class="!wd-mb-0 wd-text-base wd-text-black50 wd-break-all">{{ campaign.title }}</p>
      <p v-if="campaign.description" class="!wd-mb-0 wd-text-sm wd-text-gray80 wd-break-all">
        {{ campaign.description }}
      </p>
    </div>

    <!-- Trailing: chevron (only when clickable) -->
    <FunnowIcon v-if="isClickable" image-path="chevron-right.svg" class="wd-w-6 wd-h-6 wd-text-black50" />
  </div>
</template>

<script setup lang="ts">
import FunnowIcon from '@/components/icons/funnow-icon.vue'
import PromoCampaignModal from '@/components/dialog/PromoCampaignModal.vue'
import { useGlobalStore } from '@/store-pinia/global'
import { EdbBannerLinkType, type ProductCampaignInfo } from '@/types/api'

const props = defineProps<{
  campaign: ProductCampaignInfo
}>()

const globalStore = useGlobalStore()

const isClickable = computed(() => props.campaign.link_type !== EdbBannerLinkType.BannerLinkTypeNone)

function handleClick() {
  if (!isClickable.value) return

  const { link_type, link_target } = props.campaign

  if (link_type === EdbBannerLinkType.BannerLinkTypeRelativePath) {
    // link_target 格式：/campaign/{id}
    const match = link_target?.match(/\/campaign\/(\d+)/)
    const promoCampaignId = match ? match[1] : null

    if (promoCampaignId) {
      globalStore.setRootDynamicComponentOption({ promoCampaignId })
      globalStore.setRootDynamicComponent(PromoCampaignModal)
      globalStore.setShouldRootDynamicComponentShow(true)
    }
    return
  }

  // link_type 1 (URL) / 2 (AbsolutePath) → 新分頁開啟
  if (link_target) {
    window.open(link_target, '_blank', 'noopener,noreferrer')
  }
}
</script>
